import { useEffect, useState } from "react";
import { call } from "../Methods"
import { Link } from "react-router-dom";
import FormModal from "../Components/FormModal";
import Table from "../Components/AdminTable";

function Settings () {
  const [settings,setSettings] = useState([]);
  const [updateTable,setUpdateTable] = useState(false);
  const pageName = 'settings';
  const pageTitle = 'Tənzimləmələr'

  const getSettings = async()=>{
    const _settings = await call.forLoggedUser.setting.getSettings({})
    if(_settings.success){
        setSettings(_settings.data);
        console.log(_settings.data)
    }
  }

  useEffect(()=>{
    getSettings();
  },[])


const tableSettings = {
    name: '',
    label: '',
    filters:true,
    rowCountInfo:false,
    rowNumbers:false,
    actions: {
      get: async (params = {}) => {
        const settings = await call.forLoggedUser.setting.getSettings(params)
        if (settings.success) {
          return settings.data
        }
        return []
      }
    },
    columns: [
      {
        title: 'Açar',
        property: 'name',
        style: { width: '25%' },
        filter: {
          enabled: true,
          type: 'text',
          name:'name'
        },
        mutate:(value)=>{
          return <span style={{fontWeight:'500'}}>{value}</span>
        }
      },
      {
        title: 'Açıqlama',
        property: 'description',
        style: { width: '15%' },
        filter: {
          enabled: false,
          type: 'text',
          name:'description'
        },
        sort: {
          enabled: true
        },
        mutate:(value)=>{
          return <span style={{fontStyle:'italic'}}>{value}</span>
        }
      },
      {
        title: 'Dəyər',
        property: 'value',
        style: { width: '45%'},
        filter: {
          enabled: true,
          type: 'text',
          name:'value'
        },
        mutate:(value)=>{
          return <span style={{textIndent:'10px',display:'inline-block',width:'100%',textAlign:'left'}}>{value}</span>
        }
      },
      {
        title: 'Əməliyyat',
        property: 'id',
        type: 'actions-list',
        operations: value => [
          {
            type:'link',
            name:'Edit',
            title:'Düzəliş',
            link:`${value}`,
            iconType:'path',
            icon:'/Images/Icons/edit.png',
            disablingConditions:[],
          },
        ],
        style: {width:'15%',minWidth: '120px'}
      }
    ]
  }

const formSettings = [{
      name: 'settings',
      id: '',
      label: 'Tənzimləmə',
      isMain: true,
      actions: {
        get: id => call.forLoggedUser.setting.getSettingById({ id: id }),
        edit: call.forLoggedUser.setting.updateSettings
      },
      fields: [
        {
          label: '',
          fieldName: 'id',
          type:'hidden',
        },
        {
          label: 'Ad',
          fieldName: 'name',
          type:'readonly-text',
          col: { sm: 6 }
        },
        {
          label: 'Açıqlama',
          fieldName: 'description',
          type:'readonly-text',
          col: { sm: 6 }
        },
        {
          label: 'Dəyər',
          fieldName: 'value',
          type:'text',
          validationRules: ['required'],
          col: { sm: 6 }
        },
        { type: 'submit', label: 'Təsdiq', col: { sm: 12 } }
      ]
}]

  return (
    <div className='page settings-page'>
      <h1 className='page-title'>Tənzimləmələr</h1>
      {settings?.length>0 && <div className='settings-section page-section'>
        <h2 className='section-header'></h2>
        <Table tableSettings={tableSettings} updateTable={updateTable} />

        <FormModal
        moduleUrl={`/${pageName}`}
        formSettings={formSettings}
        onSubmit={() => setUpdateTable(true)}
      />
      </div>}
    </div>
  )
}

export default Settings
